import React from 'react'

export type ThermoboardRoba = {
  brojNaloga: string
  stavka: string
  brojPonude: string
  sifra: string
  boja: string
  paketi: string
  napomena: string
  istovar: string
}

export const createThermoboardRoba = (): ThermoboardRoba => ({
  brojNaloga: '',
  stavka: '',
  brojPonude: '',
  sifra: '',
  boja: '',
  paketi: '',
  napomena: '',
  istovar: '',
})

const fields: {key: keyof ThermoboardRoba; label: string}[] = [
  {key: 'brojNaloga', label: 'Broj naloga'},
  {key: 'stavka', label: 'Stavka'},
  {key: 'brojPonude', label: 'Broj ponude'},
  {key: 'paketi', label: 'Brojevi paketa'},
  {key: 'napomena', label: 'Napomena'},
]

type Props = {
  rows: ThermoboardRoba[]
  onChange: (rows: ThermoboardRoba[]) => void
}

const ThermoboardRobaTable = ({rows, onChange}: Props) => {
  const updateRow = (index: number, field: keyof ThermoboardRoba, value: string) => {
    onChange(rows.map((row, rowIndex) => (rowIndex === index ? {...row, [field]: value} : row)))
  }

  return (
    <>
      <p className='text-muted'>
        Unesite podatke o robi. Brojeve paketa odvojite zarezom, a za dodatne stavke dodajte novi
        red.
      </p>
      <div className='table-responsive'>
        <table className='table table-bordered align-middle'>
          <thead>
            <tr className='fw-bold bg-light'>
              {fields.map(({key, label}) => (
                <th key={key} scope='col'>
                  {label} {key === 'brojNaloga' && <span className='text-danger'>*</span>}
                </th>
              ))}
              <th scope='col'>
                Odaberi Istovar <span className='text-danger'>*</span>
              </th>
              <th scope='col'>
                <span className='visually-hidden'>Ukloni red</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <tr key={index}>
                {fields.map(({key, label}) => (
                  <td
                    key={key}
                    style={{minWidth: key === 'napomena' ? 200 : key === 'stavka' ? 90 : 140}}
                  >
                    <input
                      type='text'
                      className='form-control form-control-solid'
                      aria-label={`${label}, red ${index + 1}`}
                      aria-required={key === 'brojNaloga'}
                      value={row[key]}
                      onChange={(e) => updateRow(index, key, e.target.value)}
                    />
                  </td>
                ))}
                <td style={{minWidth: 160}}>
                  <select
                    className='form-control form-control-solid'
                    aria-label={`Istovar, red ${index + 1}`}
                    aria-required='true'
                    value={row.istovar}
                    onChange={(e) => updateRow(index, 'istovar', e.target.value)}
                  >
                    <option value=''>Odaberi</option>
                    <option value='Istovar 1'>Istovar 1</option>
                    <option value='Istovar 2'>Istovar 2</option>
                  </select>
                </td>
                <td>
                  <button
                    type='button'
                    className='btn btn-sm btn-light-danger'
                    aria-label={`Ukloni red ${index + 1}`}
                    disabled={rows.length === 1}
                    onClick={() => onChange(rows.filter((_, rowIndex) => rowIndex !== index))}
                  >
                    Ukloni
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <button
        type='button'
        className='btn btn-sm btn-light-primary'
        onClick={() => onChange([...rows, createThermoboardRoba()])}
      >
        Dodaj red
      </button>
    </>
  )
}

export default ThermoboardRobaTable
